<script>
export default {
  methods: {
    $isMobile() {
      return screen.width < 768;
    },
  },
};
</script>
